import { logStatusDisplay } from 'src/app/shared/flight-log-api/flight-logs/flight-log-client-model-helpers';
import { LogStatus } from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.model';
import { FlightLogFindMyFlightProps } from 'src/store/flight-log/flight-log.model';

class FlightLogFindMyFlightViewModelBase implements FlightLogFindMyFlightProps {
  private readonly _jsonValue: any;
  public id?: string;
  public companyId?: string;
  public flightTagNumber?: string;
  public flightSummaryId?: string;
  public status: LogStatus;
  public flightTime?: Date;
  public updatedBy?: string;
  public updatedAt?: string;
  public tailNumber?: string;
  constructor(props: FlightLogFindMyFlightProps) {
    this._jsonValue = props;
    Object.assign(this, props);
  }

  get logStatusDisplay() {
    return logStatusDisplay(this.status);
  }

  public toJSON() {
    return this._jsonValue;
  }
}
export class FlightLogFindMyFlightViewModel
  extends FlightLogFindMyFlightViewModelBase
  implements FlightLogFindMyFlightProps {
  constructor(flightLogFindMyFlight: FlightLogFindMyFlightProps) {
    super(flightLogFindMyFlight);
    Object.assign(this, flightLogFindMyFlight);
  }

  public static fromJS(flightLog: FlightLogFindMyFlightProps): FlightLogFindMyFlightViewModel {
    if (flightLog instanceof FlightLogFindMyFlightViewModel) {
      return flightLog;
    }
    return new FlightLogFindMyFlightViewModel(flightLog);
  }
}
